import { render, staticRenderFns } from "./SwabSampleAnalysisChartBody.vue?vue&type=template&id=03ef36d3&"
import script from "./SwabSampleAnalysisChartBody.vue?vue&type=script&lang=ts&"
export * from "./SwabSampleAnalysisChartBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports